<template>
  <div>
    <div class="row border-top mt-5 p-2">
      <div class="col mt-3">
        <h4>Performance</h4>
      </div>
    </div>

    <div class="row p-2">
      <div class="col min-width-chart mx-auto my-auto pb-3">
        <doughnutChart
          :chart-data="engagement.Performance"
          :options="engagement.chartOptions"
          :textMiddle="engagement.PerformanceValue"
        ></doughnutChart>
      </div>

      <div class="col-10 border-left if-small-no-border">
        <div class="row border-bottom if-small-add-border">
          <div class="col pt-3 my-auto">
            <div class="text-center"><h5>Performance</h5></div>
            <p>
              Performance refers to the production work and is calculated
              according to the set goals (norm).
            </p>
          </div>
          <div class="col max-width-chart p-2 my-auto">
            <doughnutChart
              :chart-data="engagement.Performance"
              :options="engagement.chartOptions"
              :textMiddle="engagement.PerformanceValue"
            ></doughnutChart>
          </div>
          <div class="col pt-3 my-auto border-left">
            <div><h5>Possible solutions:</h5></div>
            <p>Low performance has two main causes: low engagement or improper training</p>
            <ul>
              <li>Engage the employee by talking with them and motivating them</li>
              <li>Try giving the employee some extra training if you feel he isn’t trained enough</li>
              <li>Let a high performing employee show his way of doing things to this employee</li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="col pt-3 my-auto">
            <div class="text-center"><h5>Registered input</h5></div>
            <p>
              The registered input is not taken up in the Employee Engagament
              Index, however it does serve as an indication of engagement.
            </p>
          </div>
          <div class="col max-width-chart p-2 my-auto">
            <div class="row">
              <div class="col">
                <p><small>Feedback:</small></p>
              </div>
              <div class="col">
                <p><small>12</small></p>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p><small>Feedback:</small></p>
              </div>
              <div class="col">
                <p><small>2</small></p>
              </div>
            </div>
          </div>
          <div class="col pt-3 my-auto border-left">
            <div><h5>Consideration:</h5></div>
            <ul>
              <li>The employee might not be using the performance management tool (Motivate)</li>
              <li>There is nothing to submit</li>
              <li>Try showing employees how they can submit feedback and improvements</li>
              <li>Reward feedback and improvements and thank them for their contribution</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import doughnutChart from "@/components/engagement/charts/percentageDoughnutChart.js";
import { Doughnut, mixins } from "vue-chartjs";

import { adjustColor } from "@/mixins/engagement/adjustChartColor.js";

export default {
  extends: Doughnut,
  mixins: [mixins.reactiveProp, adjustColor],
  props: ["chartData"],
  components: {
    doughnutChart,
  },
  data() {
    return {
      engagement: {
        EmployeeUID: null,
        EmployeeName: null,
        EmployeeEngagementIndex: null,
        EmployeeEngagementIndexValue: null,
        EngagementScale: null,
        EngagementScaleValue: null,
        vigor: null,
        dedication: null,
        absorption: null,
        Performance: null,
        PerformanceValue: null,
        Evaluation: null,
        EvaluationValue: null,
        Communication: null,
        Relationships: null,
        Planning: null,
        Results: null,
        Resilience: null,
        Supporting: null,
        Progression: null,
        chartOptions: {
          responsive: true,
          maintainAspectRatio: true,
          cutoutPercentage: 60,
          legend: {
            display: false,
          },
          tooltips: false,
          plugins: {
            datalabels: {
              display: function (ctx) {
                return false;
              },
            },
          },
        },
      },
    };
  },

  mounted() {
    this.fillData();
  },
  methods: {
    fillData() {
      this.engagement.PerformanceValue = 99;
      this.engagement.Performance = {
        datasets: [
          {
            data: [
              this.engagement.PerformanceValue,
              100 - this.engagement.PerformanceValue,
            ],
            backgroundColor: [
              this.adjustColor(this.engagement.PerformanceValue),
            ],
            borderWidth: 0,
          },
        ],
        labels: ["Employee Engagement Index"],
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeOverviewInDepth.scss";
</style>